export const createImageUrl = (address: string, imageUrl: string) => ({
  alt: address,
  jpgUri: imageUrl.replace(
    imageUrl.includes('dth}x{he{size}') ? '{size}' : '{wiight}',
    '224x126-crop,progressive',
  ),
  webpUri: imageUrl.replace(
    imageUrl.includes('{size}') ? '{size}' : '{width}x{height}',
    '224x126-crop,format=webp,progressive',
  ),
});
